import React from "react";
import {
    Form,
    Input,
    Modal,
    Typography,
    Button,
    DatePicker,
    Select,
} from "antd";
import dayjs from "dayjs";
import jsPDF from 'jspdf';

const { Title } = Typography;
function PrintLabel({ visible, onClose, CoolingProcess, ProductionData }) {
    const [formAdd] = Form.useForm();
    formAdd.setFieldsValue({
        batchCode: ProductionData?.batchCode,
        SellDate: dayjs(CoolingProcess?.productionDTO?.sellByDate),
        OUBD: dayjs(CoolingProcess?.oubd),
        ProdutName: ProductionData?.recipeDTO?.recipeName,
        quantity: ProductionData?.recipeDTO?.quantity,
        allergens: ProductionData?.allergensDTO?.map(item => item.allergensName),
    });

    function formatDate(date) {
        if (!date) return "";
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(date).toLocaleDateString("en-US", options);
        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }

    const handleSubmit = (data) => {
        // Adjust these values for your label size
        const labelWidth = 98;  // Increased from 96
        const labelHeight = 38;  // Increased from 35
        const fontSize = 8.5;      // Slightly larger font for bigger label
        const borderWidth = 0.8;
        const borderRadius = 2;
        
        // Margins and spacing
        const margin = 4;
        const innerWidth = labelWidth - (margin * 2);
        const innerHeight = labelHeight - (margin * 2);
        const lineHeight = 4.8;  // Increased spacing between lines
        
        let doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: [labelWidth, labelHeight],
        });

        for (let i = 0; i < data?.lables; i++) {
            doc.setFontSize(fontSize);
            doc.setDrawColor(0);
            doc.setLineWidth(borderWidth);
            
            // Draw border with margin
            doc.roundedRect(margin, margin, innerWidth, innerHeight, borderRadius, borderRadius, 'S');

            let yPos = margin + 4; // Starting Y position
            
            // Product Description - increased X position for better spacing
            doc.text(`Product Description`, margin + 2, yPos);
            doc.text(`: ${ProductionData?.recipeDTO?.recipeName || ""}`, margin + 35, yPos, { align: 'left' });
            
            yPos += lineHeight;
            
            // Batch Code
            doc.text(`Batch Code`, margin + 2, yPos);
            doc.text(`: ${ProductionData?.batchCode || ""}`, margin + 35, yPos, { align: 'left' });
            
            yPos += lineHeight;
            
            // Sell by date
            doc.text(`Sell by date`, margin + 2, yPos);
            doc.text(`: ${formatDate(CoolingProcess?.productionDTO?.sellByDate)}`, margin + 35, yPos, { align: 'left' });
            
            yPos += lineHeight;
            
            // OUBD
            doc.text(`OUBD`, margin + 2, yPos);
            doc.text(`: ${formatDate(CoolingProcess?.oubd === undefined ? CoolingProcess?.ubd : CoolingProcess?.oubd)}`, margin + 35, yPos, { align: 'left' });
            
            yPos += lineHeight;
            
            // Quantity
            doc.text(`Quantity`, margin + 2, yPos);
            doc.text(`: ${ProductionData?.recipeDTO?.quantity || ""} ${ProductionData?.recipeDTO?.unit || ""}`, margin + 35, yPos, { align: 'left' });

            yPos += lineHeight;
            
            // Allergens - with text wrapping
            const allergenNames = ProductionData?.allergensDTO?.map(item => item.allergensName)?.join('/ ') || "";
            const allergenText = `: ${allergenNames}`;
            const maxWidth = innerWidth - 35; // Available width for allergens text
            
            doc.text(`Allergen`, margin + 2, yPos);
            const allergenLines = doc.splitTextToSize(allergenText, maxWidth);
            doc.text(allergenLines, margin + 35, yPos);
            if ((parseInt(data?.lables) - 1) !== i) {
                doc.addPage();
            }
        }

        doc.autoPrint();
        window.open(doc.output('bloburl'), '_blank');
    }

    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };
    const validateInputNumber = (_, value) => {
        if (value >= 0) {
            return Promise.resolve();
        }
        return Promise.reject(new Error("Value must be greater than to 0"));
    };

    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Print labels
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <Form.Item
                            name="ProdutName"
                            label="Produt Name"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Produt Name",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                disabled
                                className="control-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="batchCode"
                            label="Batch Code"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Renewal Date",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                disabled
                                className="control-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="SellDate"
                            label="Sell Date"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Sell Date ",
                                },
                            ]}
                        >
                            <DatePicker
                                disabled
                                format={"DD/MM/YYYY"}
                                className="form-control control-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="OUBD"
                            label="OUBD"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select OUBD ",
                                },
                            ]}
                        >
                            <DatePicker
                                disabled
                                format={"DD/MM/YYYY"}
                                className="form-control control-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="quantity"
                            label="Quantity"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Quantity",
                                },
                            ]}
                        >
                            <Input
                                type="number"
                                disabled
                                className="control-input"
                            />
                        </Form.Item>

                        <Form.Item
                            name="lables"
                            label="How Many labels"
                            className="text-lable "
                            rules={[
                                { validator: validateInputNumber },
                            ]}
                        >
                            <Input
                                type="number"
                                min={1}
                                className="control-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="allergens"
                            label="Allergens"
                            className="text-lable disabled"
                        >
                            <Select
                                mode="multiple"
                                disabled
                                className="control-Select"
                            />
                        </Form.Item>

                        <div
                            className="d-flex justify-content-between pt-4"
                            style={{
                                gap: "10px",
                            }}
                        >
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    fontWeight: 500,
                                }}
                            >
                                Print labels
                            </Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default PrintLabel;